<template>
	<v-container class="pa-1">

    <v-snackbar v-model="alerta.activo" multi-line :vertical="true" top right :color="alerta.color" > 
      <strong> {{alerta.texto}} </strong>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text @click="alerta.activo = false" v-bind="attrs"> Cerrar </v-btn>
      </template>
    </v-snackbar>

    <v-card-actions>
      <div class="font-weight-black text-md-h6 text-xs-subtitle-1 "> Costo de envío   </div>
      <v-spacer></v-spacer>
      <v-btn color="error" fab small elevation="1" @click="$emit('modal',false)" ><v-icon>clear</v-icon></v-btn>
    </v-card-actions>

    <!-- <v-container style="height: 300px;" v-if="Loading">
      <loading/>
    </v-container> -->

      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="costo_envio" 
            label="Costo de envío" 
            dense filled hide-details 
            color="primary" 
            append-icon="mdi-currency-usd" 
            type="number"
            class="font-weight-black subtitle-1"
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="mt-10"></div>

      <v-footer absolute >
        <v-spacer></v-spacer>
        <v-btn class="primary" 
          @click="modalCostoEnvio = true"
        > Actualizar </v-btn>
      </v-footer>
      
    
    <v-dialog v-model="modalCostoEnvio" persistent width="400">
        <v-card>
          <v-card-title class="subtitle-1 font-weight-black " style="word-break:normal;">¿ESTÁS SEGURO DE QUERER MODIFICAR EL COSTO DEL ENVÍO ? </v-card-title>
          <v-divider class="my-0 py-3" ></v-divider>
          <v-card-subtitle align="center" class="red--text font-weight-bold "> NO SE PODRÁ RECUPERAR </v-card-subtitle>
          <v-divider class="my-0 py-2 " ></v-divider>
          <v-card-actions>
            <v-btn color="error" dark @click="modalCostoEnvio=false" >  NO, Cancelar </v-btn>
            <v-spacer/>
            <v-btn color="primary" text @click="actualizaCostoEnvio()" >  SÍ, Actualizar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

		<overlay v-if="overlay"/>
  </v-container>
</template>

<script>
  import  metodos from '@/mixins/metodos.js';
	import {mapGetters, mapActions} from 'vuex'
  // import loading from '@/components/loading.vue'
  import overlay from '@/components/overlay.vue'

  export default {
    mixins:[metodos],
	  components: {
			// loading,
      overlay
		},
		props:[
			'parametros',
	  ],

    data(){
      return{
        // Loading: false,
        costo_envio:0,
        ObjectDefault:{},
        alerta: { activo: false, texto:'', color:'error' },
        overlay: false,
        modalCostoEnvio: false, 

      }
    },

    created(){
				this.initialize();
		},

    watch:{
			parametros(){
				this.initialize();
			},
    },
			
		computed:{
			// IMPORTANDO USO DE VUEX - CLIENTES (GETTERS)
      ...mapGetters('Login',['getusuarioFetish']),
		},

    watch: {

    },

    methods:{
      
      async initialize(){
        let costo = await this.consultar_costo_envio();
        this.costo_envio = costo[0].costo_envio
      },

      async actualizaCostoEnvio() {
        this.overlay = true;
        this.modalCostoEnvio = false;
        
        const ModifCost = await this.actualiza_costo_envio(this.costo_envio);

        if(ModifCost){
          var that = this;
          this.overlay = false
          this.alerta = { activo: true, color:'success', texto: "Costo de envio actualizado Correctamente" };
          setTimeout(() => { that.$emit('modal') }, 1000);
          // this.finalizarProceso();
        }else{
          this.overlay = false
          this.alerta = { activo: true, color:'error', texto: 'Ocurrio un error al actualizar el costo de envio' };
        }

        // this.$http.post('actualiza.costo.envio').then( response =>{
        //   var that = this;
        //   this.alerta = { activo: true, color:'success', texto: "Costo de envio actualizado Correctamente" };
        //   setTimeout(() => { that.$emit('modal') }, 1000);
        //   this.finalizarProceso()
        // }).catch( error =>{
        //   console.log('error', error);
        //   this.alerta = { activo: true, color:'error', texto: error.message };
        // }).finally(()=>{ 
        //   this.overlay = false
        // })

      }

    } 

  }
</script>